import MarketingLayout from '../components/marketing/MarketingLayout';
import { colors } from '../lib/colors';

export default function Testimonials() {
  const gradientStyle = {
    background: `radial-gradient(circle at center, ${colors.premium.dark} 0%, ${colors.premium.darker} 100%)`
  };

  const testimonials = [
    {
      name: "Sarah M., Business Owner",
      quote: "They helped us secure our buy-sell agreement without any hassle. The process was seamless and saved us a lot in potential taxes."
    },
    {
      name: "John D., Retiree",
      quote: "Their insured retirement strategy gave me peace of mind. I can access funds tax-free, and my estate remains fully protected."
    },
    {
      name: "A. Smith, Entrepreneur",
      quote: "I was skeptical at first, but their 'giant TFSA' approach truly boosted my investment growth. Highly recommended."
    },
  ];

  return (
    <MarketingLayout>
      <section className="min-h-screen" style={gradientStyle}>
        <div className="max-w-4xl mx-auto py-12 px-3">
          <h1 className="text-3xl md:text-4xl font-bold mb-6">Testimonials</h1>
          <p className="text-premium-light mb-8 max-w-xl text-sm">
            See what high-net-worth Canadians are saying about our 
            advanced insurance strategies.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {testimonials.map((test, i) => (
              <div
                key={i}
                className="bg-premium-dark p-4 rounded-lg border border-gray-800/50"
              >
                <p className="italic mb-3 text-sm">"{test.quote}"</p>
                <p className="text-xs text-premium-light font-semibold">
                  — {test.name}
                </p>
              </div>
            ))}
          </div>
          <div className="mt-8">
            <button className="btn-primary text-sm px-4 py-2">Contact Us</button>
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}